import { React, Component, createRef } from "react";
import { addSubUser, checkResllerAccount } from "./../../../config/api_calls";
import { LOGO, APP_URL, THEME_COLOR } from "../../../config/config";
import { ValidateEmail } from "../../../config/utility";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import HelperClass from "./../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import { withRouter } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
//import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import countryList from "react-select-country-list";
import PasswordStrengthBar from "react-password-strength-bar";
import ImgError from "../../../assets/images/error-404.svg";
import GoogleImage from "../../../assets/images/google.png";

import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();
const decodeEmail = (encodedEmail) => {
  return Buffer.from(encodedEmail, "base64").toString("utf-8");
};
export default withRouter(
  class Register extends Component {
    constructor() {
      super();
      this.state = {
        comp_name: "",
        name: "",
        title: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        password: "",
        confirm_password: "",
        errorEmail: "",
        errorPass: "",
        errorcPass: "",
        errorName: "",
        errorMessage: "",
        errorCompName: "",
        errorTitle: "",
        disabled: false,
        successMessage: "",
        confirm_password: "",
        errorConfirm: "",
        errorPhone: "",
        tableLoader: true,
        pageError: "",
        step: 1,
        passwordShown: false,
        confirmPasswordShown: false,
        address2: "",
        country: "United States",
        errorAddress: false,
        errorAdminType: false,
        errorCity: false,
        errorState: false,
        errorZip: false,
        errorCountry: false,
        useGooglePlaces: true,
        toggleButtonText: "Allow PO Box Address",
        verification_link: "",
        address_autocomplete: true,
        address_validation: true,
        checkValidation: "No",
        reseller_accountno: "",
        social_register: false,
        listMenuGroupData: [],
        selected_group_id: "",
        required_sub_user_type: false,
      };
      this.site_key = process.env.REACT_APP_CAPTCHA_SITE_KEY;
      this.captcha_token = null;
      this.phoneInputRef = createRef();
      this.countryOptions = countryList().getData().sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
    }

    getEmailFromURL = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get("email");
    };

    getNameFromURL = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get("name");
    };

    getTitleFromURL = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get("title");
    };

    getParamFromURL(paramName) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(paramName);
    }

    generateStrongPassword = (length) => {
      const lowercaseCharset = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseCharset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numberCharset = "0123456789";
      const specialCharset = "!@#$%^&*()-_=+";

      let password = "";

      password +=
        lowercaseCharset[Math.floor(Math.random() * lowercaseCharset.length)];
      password +=
        uppercaseCharset[Math.floor(Math.random() * uppercaseCharset.length)];
      password +=
        numberCharset[Math.floor(Math.random() * numberCharset.length)];
      password +=
        specialCharset[Math.floor(Math.random() * specialCharset.length)];

      const remainingLength = length - 4;

      const combinedCharset =
        lowercaseCharset + uppercaseCharset + numberCharset + specialCharset;
      for (let i = 0; i < remainingLength; i++) {
        const randomIndex = Math.floor(Math.random() * combinedCharset.length);
        password += combinedCharset[randomIndex];
      }

      password = this.shuffleString(password);

      return password;
    };

    shuffleString = (str) => {
      const array = str.split("");
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array.join("");
    };

    async componentDidMount() {
      let signup_hash = this.props.match.params.signup_hash;
      const verification_link = window.location.href;
      let checkValidation = verification_link.includes("?email=")
        ? "Yes"
        : "No";
      this.setState({
        loader: "checking",
        verification_link: verification_link,
      });

      if (signup_hash !== "") {
        // console.log("Its Here");
        let email = this.getEmailFromURL();
        email = email ? decodeEmail(email) : "";

        let name = this.getNameFromURL();
        name = name ? decodeEmail(name) : "";

        let title = this.getTitleFromURL();
        title = title ? decodeEmail(title) : "";

        let comp = this.getParamFromURL("admin_comp");
        let comp_name = comp
          ? Buffer.from(comp, "base64").toString("utf8")
          : "";

        // console.log("Email:", email);
        // console.log("comp_name:", comp_name);

        this.setState({
          email: email || "",
          comp_name: comp_name || "",
          name: name || "",
          title: title || "",
        });

        try {
          this.setState({ tableLoader: true });

          let response = await checkResllerAccount({
            signup_hash: signup_hash,
            token: process.env.REACT_APP_API_TOKEN,
            api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            verification_link: verification_link,
            checkValidation: checkValidation,
          });

          if (response.data.status === 200) {
            const settings = response.data.custom_settings?.[0] || {};
            const address_autocomplete = settings.address_autocomplete || "No";
            const address_validation = settings.address_validation || "No";
            const required_sub_user_type =
              settings.required_sub_user_type || "No";
            const reseller_accountno = response.data.reseller_accountno;

            const groupData = response.data.menu_group;

            this.setState({
              loader: "",
              address_autocomplete,
              address_validation,
              required_sub_user_type,
              reseller_accountno,
              listMenuGroupData: groupData,
              tableLoader: false,
            });

            this.autoSelectDefaultGroup(groupData);

            let session_userName = localStorage.getItem("userName");
            let session_userEmail = localStorage.getItem("userEmail");
            let session_userSub = localStorage.getItem("userSub");
            let session_userComp = localStorage.getItem("userComp");
            let session_userPhone = localStorage.getItem("userPhone");
            let session_userAddress = localStorage.getItem("userAdress");
            let session_userAddress2 = localStorage.getItem("userAdress2");
            let session_userState = localStorage.getItem("userState");
            let session_userCity = localStorage.getItem("userCity");
            let session_userZip = localStorage.getItem("userZip");
            let session_userCountry = localStorage.getItem("userCountry");
            let session_authProvider = localStorage.getItem("authProvider");
            const isSocialRegister =
              session_userName !== null &&
              session_userName !== "" &&
              session_userEmail !== null &&
              session_userEmail !== "" &&
              session_userSub !== null &&
              session_userSub !== "" &&
              session_userComp !== null &&
              session_userComp !== "" &&
              session_authProvider !== null &&
              session_authProvider !== "";
            if (isSocialRegister) {
              const random_password = this.generateStrongPassword(12);
              this.setState({
                name: session_userName,
                email: session_userEmail,
                comp_name: session_userComp,
                phone: session_userPhone,
                address: session_userAddress,
                address2: session_userAddress2,
                city: session_userCity,
                state: session_userState,
                zip: session_userZip,
                country: session_userCountry,
                social_register: true,
                password: random_password,
                confirm_password: random_password,
              });
            }
            // console.log("Signup hash is valid");
          } else if (response.data.status === 404) {
            // console.log("Signup hash not found");
            this.setState({
              pageError:
                "Signup hash not found. Please enter a valid URL or contact admin for more details.",
              loader: "",
            });
          } else if (
            response.data.status === 409 &&
            response.data.message === "No verification link found"
          ) {
            this.setState({
              pageError: "This invitation link is no longer valid.",
              errorMessage: "",
              successMessage: "",
              loader: "",
            });
          } else {
            // console.log("Error checking signup hash:", response.data.status);
          }
        } catch (error) {
          console.error("Error checking signup hash:", error);
          this.setState({
            pageError:
              "There is some error. Please try again or contact support.",
          });
        } finally {
          this.setState({ tableLoader: false });
        }
      } else {
        // console.log("Signup hash is empty");
      }
    }

    handleFocus = () => {
      // Move cursor to the end of the input value
      const input = this.phoneInputRef.current;
      if (input) {
        const value = input.value;
        input.setSelectionRange(value.length, value.length);
      }
    };

    addMenuHistory = (link) => {
      this.props.props.history.push(link);
    };

    phoneUtil = PhoneNumberUtil.getInstance();

    isPhoneValid = (phone) => {
      try {
        return this.phoneUtil.isValidNumber(
          this.phoneUtil.parseAndKeepRawInput(phone),
        );
      } catch (error) {
        return false;
      }
    };

    handleChange = async (event) => {
      const { target } = event;
      let value = target.type === "checkbox" ? target.checked : target.value;
      const { name } = target;
      if (name === "name") {
        value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
      } else if (name === "comp_name") {
        value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
      } else if (name === "title") {
        value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
      }
      this.setState({
        [name]: value,
      });
      //console.log("handleChange: ", name + " " + value);
    };

    togglePassword = () => {
      this.setState({
        passwordShown: !this.state.passwordShown,
      });
    };

    toggleConfirmPassword = () => {
      this.setState({
        confirmPasswordShown: !this.state.confirmPasswordShown,
      });
    };

    checkNumber = async (evt) => {
      var theEvent = evt || window.event;
      var key = theEvent.keyCode || theEvent.which;
      var keyCode = key;
      key = String.fromCharCode(key);
      if (key.length == 0) return;
      var regex = /^[0-9.\b]+$/;
      if (keyCode == 188 || keyCode == 190) {
        return;
      } else {
        if (!regex.test(key)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      }
    };

    fieldValidation = () => {
      let {
        comp_name,
        name,
        title,
        email,
        password,
        address,
        city,
        state,
        zip,
        country,
        confirm_password,
        phone,
        listMenuGroupData,
        required_sub_user_type,
        selected_group_id,
      } = this.state;
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      if (name === "") {
        this.setState({
          errorName: true,
          errorCompName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorPhone: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Name is required.",
        });
        return false;
        // } else if (title === "" || title === null) {
        //   this.setState({
        //     errorTitle: true,
        //     errorCompName: false,
        //     errorName: false,
        //     errorEmail: false,
        //     errorPass: false,
        //     errorcPass: false,
        //     errorPhone: false,
        //     errorAddress: false,
        //     errorCity: false,
        //     errorState: false,
        //     errorZip: false,
        //     errorCountry: false,
        //     errorMessage: "Title is required.",
        //   });
        //   return false;
      } else if (email === "") {
        this.setState({
          errorEmail: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorPass: false,
          errorcPass: false,
          errorPhone: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Email is required.",
        });
        return false;
      } else if (!ValidateEmail(email)) {
        this.setState({
          errorEmail: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorPass: false,
          errorcPass: false,
          errorPhone: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Invalid email format.",
        });
        return false;
      } else if (phone === "") {
        this.setState({
          errorPhone: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Phone is required.",
        });
        return false;
      } else if (!this.isPhoneValid(phone)) {
        this.setState({
          errorPhone: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Invalid phone number.",
        });
        return false;
      } else if (
        this.state.listMenuGroupData &&
        this.state.listMenuGroupData.length > 0 &&
        required_sub_user_type === "Yes" &&
        (!selected_group_id || selected_group_id === "")
      ) {
        this.setState({
          errorAdminType: true,
          errorAddress: false,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorPhone: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Please select a sub user type.",
        });
      } else if (address === "") {
        this.setState({
          errorAddress: true,
          errorAdminType: false,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorPhone: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Address is required.",
        });
        return false;
      } else if (city === "") {
        this.setState({
          errorCity: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorAddress: false,
          errorAdminType: false,
          errorPhone: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "City is required.",
        });
        return false;
      } else if (state === "") {
        this.setState({
          errorState: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorAddress: false,
          errorCity: false,
          errorPhone: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "State is required.",
        });
        return false;
      } else if (zip === "") {
        this.setState({
          errorZip: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorPhone: false,
          errorState: false,
          errorCountry: false,
          errorMessage: "Zip is required.",
        });
        return false;
      } else if (country === "") {
        this.setState({
          errorCountry: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorAddress: false,
          errorCity: false,
          errorPhone: false,
          errorZip: false,
          errorState: false,
          errorMessage: "Country is required.",
        });
        return false;
      } else if (!password || password === "") {
        // console.log("My Title", this.state.title);
        this.setState({
          errorPass: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorcPass: false,
          errorPhone: false,
          errorMessage: "Password is required.",
        });
        return false;
      } else if (password !== "" && !passwordRegex.test(password)) {
        this.setState({
          errorPass: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorcPass: false,
          errorPhone: false,
          errorAddress: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        return false;
      } else if (!confirm_password || confirm_password === "") {
        this.setState({
          errorcPass: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorPhone: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Confirm password is required.",
        });
        return false;
      } else if (!confirm_password || confirm_password.length < 8) {
        this.setState({
          errorcPass: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorPhone: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        return false;
      } else if (password !== confirm_password) {
        this.setState({
          errorcPass: true,
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorPhone: false,
          errorAddress: false,
          errorAdminType: false,
          errorCity: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "Password and confirm password do not match.",
        });
        return false;
      } else {
        this.setState({
          errorCompName: false,
          errorName: false,
          errorTitle: false,
          errorEmail: false,
          errorPass: false,
          errorcPass: false,
          errorPhone: false,
          errorAddress: false,
          errorCity: false,
          errorAdminType: false,
          errorState: false,
          errorZip: false,
          errorCountry: false,
          errorMessage: "",
          disabled: true,
        });
        return true;
      }
    };

    formSave = async () => {
      let {
        name,
        email,
        password,
        confirm_password,
        phone,
        comp_name,
        title,
        address,
        city,
        state,
        zip,
        address2,
        country,
        oauth_identifier,
        authProvider,
        reseller_accountno,
      } = this.state;
      oauth_identifier = localStorage.getItem("userSub");
      authProvider = localStorage.getItem("authProvider");
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (this.fieldValidation() === true) {
        this.setState({
          errorMessage: "",
          disabled: true,
        });

        const saveResponce = await addSubUser(
          auth.getAccount() || reseller_accountno,
          auth.getToken(),
          name,
          email,
          password,
          phone,
          comp_name,
          title,
          address,
          city,
          state,
          zip,
          address2,
          country,
          oauth_identifier,
          authProvider,
          this.state.selected_group_id,
        );
        // console.log("ADD RES: ", saveResponce.data);
        if (
          saveResponce.data.status === 403 ||
          saveResponce.data.errors === "authentication missing" ||
          saveResponce.data.errors === "jwt expired"
        ) {
          auth.logout();
        } else if (
          saveResponce.data.status === 404 &&
          saveResponce.data.message === "Account Already Exists"
        ) {
          // window.location.replace("/error");
          this.setState({
            errorMessage: "Email Already Exists",
            successMessage: "",
            disabled: false,
          });
        } else if (
          saveResponce.data.status === 409 &&
          saveResponce.data.message === "Address validation failed"
        ) {
          this.setState({
            errorMessage:
              "Address validation failed. Check if zip, state, city, and country are correctly matched.",
            disabled: false,
          });
        } else if (
          saveResponce.data.status === 200 &&
          saveResponce.data.message === "Success"
        ) {
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("authProvider");
          localStorage.removeItem("userSub");
          localStorage.removeItem("userComp");
          localStorage.removeItem("userPhone");
          localStorage.removeItem("userAdress");
          localStorage.removeItem("userState");
          localStorage.removeItem("userCity");
          localStorage.removeItem("userZip");
          localStorage.removeItem("userCountry");
          this.setState({
            errorMessage: "",
            successMessage: "Sub user added successfully.",
            disabled: false,
          });
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => {
            window.location.href = "/login";
          }, 3000);
        } else if (
          saveResponce.data.status === 200 &&
          saveResponce.data.message === "Success_sso"
        ) {
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("authProvider");
          localStorage.removeItem("userSub");
          localStorage.removeItem("userComp");
          localStorage.removeItem("userPhone");
          localStorage.removeItem("userAdress");
          localStorage.removeItem("userState");
          localStorage.removeItem("userCity");
          localStorage.removeItem("userZip");
          localStorage.removeItem("userCountry");
          this.setState({
            errorMessage: "",
            successMessage:
              "Your account has been registered. Redirecting to the dashboard...",
            disabled: false,
          });
          setTimeout(() => {
            window.location.href = `${window.location.origin}/${saveResponce.data.redirect_url}`;
          }, 3000);
        } else {
          this.setState({
            errorMessage: saveResponce.data.message,
            successMessage: "",
            disabled: false,
          });
        }

        // Clear error message after 3 seconds
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 3000);
      }
    };

    handleChangeCountry = (event, option) => {
      const country = option ? option.label : "";
      this.setState({
        country: country,
      });
    };

    handleAddressSelect = async (place) => {
      const { description } = place.value;
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            description,
          )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
        );
        const data = await response.json();

        if (data.status === "OK") {
          const addressComponents = data.results[0].address_components;
          const formattedAddress = data.results[0].formatted_address;
          let city = null;
          let state = null;
          let country = null;
          let zipCode = null;
          let streetAddress = "";
          let neighborhood = null;
          let locality = null;
          let address2 = "";
          addressComponents.forEach((component) => {
            if (component.types.includes("neighborhood")) {
              neighborhood = component.long_name;
            } else if (component.types.includes("locality")) {
              locality = component.long_name;
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              state = component.short_name;
            } else if (component.types.includes("country")) {
              country = component.long_name;
            } else if (component.types.includes("postal_code")) {
              zipCode = component.long_name;
            } else if (component.types.includes("subpremise")) {
              address2 = component.long_name;
            } else if (
              ![
                "neighborhood",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "postal_code_suffix",
              ].includes(component.types[0])
            ) {
              if (streetAddress !== "") {
                streetAddress += " ";
              }
              streetAddress += component.long_name;
            }
          });
          // Check if neighborhood is part of the formatted address
          if (neighborhood && formattedAddress.includes(neighborhood)) {
            city = neighborhood;
          } else {
            city = locality;
          }
          this.setState({
            city: city && city !== "" ? city : "",
            state: state && state !== "" ? state : "",
            zip: zipCode && zipCode !== "" ? zipCode : "",
            country: country && country !== "" ? country : "",
            address: streetAddress && streetAddress !== "" ? streetAddress : "",
            address2: address2 && address2 !== "" ? address2 : "",
          });
        } else {
          console.error("Reverse geocoding request failed:", data.status);
        }
      } catch (error) {
        console.error("Error fetching reverse geocoding data:", error);
      }
    };

    handleToggle = () => {
      this.setState((prevState) => ({
        useGooglePlaces: !prevState.useGooglePlaces,
        toggleButtonText:
          prevState.toggleButtonText === "Allow PO Box Address"
            ? "Allow Simple Address"
            : "Allow PO Box Address",
      }));
    };

    handleGroupSelectionChange = (event) => {
      const selectedGroupId = event.target.value;
      this.setState({ selected_group_id: selectedGroupId });
    };

    autoSelectDefaultGroup = (groupData) => {
      if (groupData && groupData.length > 0) {
        const defaultGroup = groupData.find(
          (group) => group[5] === "Yes", // group[5] is is_default
        );

        if (defaultGroup) {
          const defaultGroupId = defaultGroup[4].toString(); // group[4] is the ID
          this.setState({
            selected_group_id: defaultGroupId,
          });
        }
      }
    };

    render() {
      const { step, useGooglePlaces, toggleButtonText } = this.state;
      const {
        comp_name,
        password,
        confirm_password,
        name,
        email,
        phone,
        title,
        address,
        city,
        state,
        zip,
        errorMessage,
        successMessage,
      } = this.state;
      const values = {
        comp_name,
        password,
        confirm_password,
        name,
        email,
        phone,
        title,
        address,
        city,
        state,
        zip,
        errorMessage,
        successMessage,
      };

      const errorStyle = this.state.errorAddress
        ? {
          input: (provided) => ({
            ...provided,
            borderColor: "red",
          }),
          control: (provided) => ({
            ...provided,
            borderColor: "red",
          }),
        }
        : {};

      return (
        <>
          <div className="nk-body npc-crypto ui-clean pg-auth">
            <div className="nk-app-root">
              <div className="nk-main ">
                <div className="nk-wrap nk-wrap-nosidebar">
                  <div className="nk-content ">
                    <div className="nk-block nk-block-middle nk-auth-body wide-md">
                      {this.state.loader === "checking" ? null : this.state
                        .pageError ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "90vh",
                            flexDirection: "column",
                            textAlign: "center",
                            padding: "20px",
                          }}
                        >
                          <img
                            className="nk-error-gfx"
                            src={ImgError}
                            alt="404 error"
                          />
                          <h3
                            style={{
                              fontSize: "24px",
                              marginBottom: "10px",
                              color: "#1e293b",
                            }}
                          >
                            Oops! Why you’re here?
                          </h3>
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#64748b",
                              marginBottom: "3rem",
                            }}
                          >
                            {this.state.pageError}
                          </p>
                          <a
                            href="/"
                            className="btn btn-lg mt-2"
                            style={{
                              backgroundColor: THEME_COLOR,
                              color: "white",
                            }}
                          >
                            Back To Home
                          </a>
                        </div>
                      ) : (
                        <>
                          <div className="brand-logo pb-4 text-center">
                            <div className="brand-logo pb-4 text-center">
                              <a className="logo-link">
                                <img
                                  className="logo-light logo-img logo-img-lg"
                                  src={LOGO}
                                  alt="logo"
                                />
                                <img
                                  className="logo-dark logo-img logo-img-lg"
                                  src={LOGO}
                                  alt="logo-dark"
                                />
                              </a>
                            </div>
                          </div>
                          <div className="card card-bordered pt-3 ">
                            {this.state.tableLoader === true ? (
                              FormLoader()
                            ) : (
                              <>
                                <div className="card-inner card-inner-lg">
                                  <div className="nk-block-head">
                                    <div className="nk-block-head-content">
                                      {this.state.social_register ? (
                                        <h4 className="nk-block-title">
                                          Sub User SignUp with
                                          <img
                                            className=""
                                            src={GoogleImage}
                                            alt="Google Image"
                                            style={{
                                              height: "35px",
                                              marginLeft: "4px",
                                            }}
                                          />
                                        </h4>
                                      ) : (
                                        <h4 className="nk-block-title">
                                          Sub User SignUp
                                        </h4>
                                      )}
                                      <div className="nk-block-des">
                                        <p
                                          style={{
                                            color: "#637381",
                                            marginTop: "25px",
                                          }}
                                        >
                                          {" "}
                                          This portal provides you access to
                                          service contracts, rates, reports, and
                                          product marketing resources you need
                                          to establish services. Please visit
                                          the main site for other Business
                                          Units.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row g-gs">
                                    <div className="col-xxl-12">
                                      <div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">
                                          <div className="card-inner">
                                            {this.state.errorMessage !== "" ? (
                                              <div
                                                className="example-alert"
                                                style={{ marginBottom: "30px" }}
                                              >
                                                <div className="alert alert-pro alert-danger">
                                                  <div className="alert-text">
                                                    <h4>Error</h4>
                                                    <p>
                                                      {this.state.errorMessage}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            {this.state.successMessage !==
                                              "" ? (
                                              <div
                                                className="example-alert"
                                                style={{ marginBottom: "30px" }}
                                              >
                                                <div className="alert alert-pro alert-success">
                                                  <div className="alert-text">
                                                    <h4>Success</h4>
                                                    <p>
                                                      {
                                                        this.state
                                                          .successMessage
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}

                                            <form
                                              method="post"
                                              className="pageForm"
                                              id="pageForm"
                                              autoComplete="off" role="presentation"
                                            >
                                              <div className="row g-4">
                                                <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <MutextField
                                                      label="Company Name"
                                                      id="comp_name"
                                                      name="comp_name"
                                                      value={
                                                        this.state.comp_name
                                                      }
                                                      placeholder="Company name"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      inputProps={{
                                                        maxLength: 100,
                                                        readOnly: true,
                                                      }}
                                                      disabled
                                                      fullWidth
                                                      error={
                                                        this.state.errorCompName
                                                      }
                                                      helpertext="Allowed characters: (  _   .   -   ,   :   &   ( )   |   !   @ )"
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <MutextField
                                                      required
                                                      label="Full Name"
                                                      id="name"
                                                      name="name"
                                                      inputProps={{
                                                        maxLength: 50,
                                                      }}
                                                      value={this.state.name}
                                                      placeholder="Full Name"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                      error={
                                                        this.state.errorName
                                                      }
                                                      helperText="Allowed characters: (  _   .   -   ,   :   &   ( )   |   !   @ )"
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <MutextField
                                                      label="Title"
                                                      id="title"
                                                      name="title"
                                                      value={this.state.title}
                                                      inputProps={{
                                                        maxLength: 30,
                                                      }}
                                                      placeholder="Title"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                      error={
                                                        this.state.errorTitle
                                                      }
                                                      helperText="Allowed characters: (  _   .   -   ,   :   &   ( )   |   !   @ )"
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>

                                                <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <MutextField
                                                      required
                                                      label="Email"
                                                      type="text"
                                                      error={
                                                        this.state.errorEmail
                                                      }
                                                      id="email"
                                                      name="email"
                                                      value={this.state.email}
                                                      inputProps={{
                                                        maxLength: 100,
                                                      }}
                                                      placeholder="Enter your email address"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>

                                                {/* <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <MutextField
                                                      label="Phone"
                                                      type="text"
                                                      id="phone"
                                                      name="phone"
                                                      inputProps={{
                                                        maxLength: 14,
                                                      }}
                                                      defaultValue={
                                                        this.state.phone
                                                      }
                                                      placeholder="Enter your phone"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      onKeyPress={() => {
                                                        this.checkNumber();
                                                      }}
                                                      variant="outlined"
                                                      fullWidth
                                                      error={
                                                        this.state.errorPhone
                                                      }
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div> */}
                                                <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <ReactPhoneInput
                                                      country="us"
                                                      value={this.state.phone}
                                                      onChange={(value) =>
                                                        this.handleChange({
                                                          target: { name: "phone", value: `+${value}` },
                                                        })
                                                      }
                                                      inputProps={{
                                                        name: "phone",
                                                        id: "phone",
                                                        required: true,
                                                        label: "Phone Number",
                                                        maxLength: 20,
                                                      }}
                                                      specialLabel="Phone Number *"
                                                      containerStyle={{ width: "100%" }}
                                                      inputStyle={{
                                                        width: "100%",
                                                        height: "56px",
                                                        borderColor: this.state.errorPhone ? "red" : "rgba(0, 0, 0, 0.23)",
                                                      }}
                                                      isValid={!this.state.errorPhone}
                                                      helperText="nter the phone number here."
                                                    />
                                                  </div>
                                                </div>

                                                {this.state.listMenuGroupData &&
                                                  this.state.listMenuGroupData
                                                    .length > 0 && (
                                                    <div className="col-md-6">
                                                      <div className="form-group">
                                                        <div className="form-control-group">
                                                          <MutextField
                                                            required
                                                            id="selected_group_id"
                                                            name="selected_group_id"
                                                            select
                                                            label={
                                                              this.state
                                                                .required_sub_user_type ==
                                                                "Yes" ? (
                                                                <>
                                                                  Sub User Type
                                                                </>
                                                              ) : (
                                                                "Sub User Type"
                                                              )
                                                            }
                                                            value={
                                                              this.state
                                                                .selected_group_id
                                                            }
                                                            onChange={
                                                              this
                                                                .handleGroupSelectionChange
                                                            } // Use the new handler
                                                            SelectProps={{
                                                              native: true,
                                                            }}
                                                            helperText=""
                                                            variant="outlined"
                                                            fullWidth
                                                            error={
                                                              this.state
                                                                .errorAdminType ===
                                                              "error"
                                                            }
                                                          autoComplete="new-password"
                                                          >
                                                            <option
                                                              key="group_default"
                                                              value=""
                                                            ></option>
                                                            {this.state
                                                              .listMenuGroupData &&
                                                              this.state
                                                                .listMenuGroupData
                                                                .length > 0 &&
                                                              this.state.listMenuGroupData.map(
                                                                (
                                                                  group,
                                                                  index,
                                                                ) => (
                                                                  <option
                                                                    key={`group_${index}`}
                                                                    value={
                                                                      group[4]
                                                                    }
                                                                  >
                                                                    {group[1]}
                                                                  </option>
                                                                ),
                                                              )}
                                                          </MutextField>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}

                                                <div className="col-md-6">
                                                  <div
                                                    className="nk-block-between-md"
                                                    style={{
                                                      position: "absolute",
                                                      zIndex: 9999,
                                                      right: "13px",
                                                      top: "-11px",
                                                    }}
                                                  >
                                                    <div className="nk-block-head-content">
                                                      <label
                                                        htmlFor="googleLocation-autocomplete"
                                                        style={{
                                                          color: "black",
                                                          fontWeight: "500",
                                                          marginBottom: "8px",
                                                        }}
                                                      >
                                                        {" "}
                                                      </label>
                                                    </div>
                                                    {this.state
                                                      .address_autocomplete ===
                                                      "Yes" && (
                                                        <div className="nk-block-head-content">
                                                          <ul className="nk-block-tools gx-3">
                                                            <li>
                                                              <a
                                                                onClick={
                                                                  this
                                                                    .handleToggle
                                                                }
                                                                className="text-primary fs-11"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  fontSize:
                                                                    "0.7rem",
                                                                }}
                                                              >
                                                                {toggleButtonText}
                                                              </a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      )}
                                                  </div>
                                                  {this.state
                                                    .address_autocomplete ===
                                                    "Yes" ? (
                                                    useGooglePlaces ? (
                                                      <GooglePlacesAutocomplete
                                                        apiKey={
                                                          process.env
                                                            .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                        }
                                                        apiOptions={{ loading: 'async' }}
                                                        selectProps={{
                                                          value: this.state
                                                            .address
                                                            ? {
                                                              label:
                                                                this.state
                                                                  .address,
                                                              value:
                                                                this.state
                                                                  .address,
                                                            }
                                                            : null,
                                                          onChange:
                                                            this
                                                              .handleAddressSelect,
                                                          placeholder: this
                                                            .state.address
                                                            ? null
                                                            : "Enter your address *",
                                                          styles: {
                                                            ...errorStyle,
                                                            input: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                              height: "47px",
                                                            }),
                                                            option: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            singleValue: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            menu: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              zIndex: 9,
                                                            }),
                                                          },
                                                        }}
                                                        className="googleLocation-autocomplete"
                                                      />
                                                    ) : (
                                                      <MutextField
                                                        required
                                                        label="PO Box Address"
                                                        id="address"
                                                        name="address"
                                                        inputProps={{
                                                          maxLength: 100,
                                                        }}
                                                        defaultValue={
                                                          this.state.address
                                                        }
                                                        placeholder="Address"
                                                        onChange={
                                                          this.handleChange
                                                        }
                                                        variant="outlined"
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      />
                                                    )
                                                  ) : (
                                                    // address_autocomplete === "No" → show PO Box only
                                                    <MutextField
                                                      required
                                                      label="Address"
                                                      id="address"
                                                      name="address"
                                                      defaultValue={
                                                        this.state.address
                                                      }
                                                      placeholder="Address"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    autoComplete="new-password"
                                                    />
                                                  )}
                                                </div>

                                                <div className="col-lg-6">
                                                  <div className="form-group">
                                                    <MutextField
                                                      label="Address2"
                                                      id="address2"
                                                      name="address2"
                                                      inputProps={{
                                                        maxLength: 100,
                                                      }}
                                                      value={
                                                        this.state.address2
                                                      }
                                                      placeholder="Address2"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>

                                                <div
                                                  className={
                                                    this.state
                                                      .listMenuGroupData &&
                                                      this.state.listMenuGroupData
                                                        .length > 0
                                                      ? "col-md-3"
                                                      : "col-md-6"
                                                  }
                                                >
                                                  <div className="form-group">
                                                    <MutextField
                                                      required
                                                      label="City"
                                                      id="city"
                                                      name="city"
                                                      inputProps={{
                                                        maxLength: 32,
                                                      }}
                                                      value={this.state.city}
                                                      placeholder="City"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>

                                                <div
                                                  className={
                                                    this.state
                                                      .listMenuGroupData &&
                                                      this.state.listMenuGroupData
                                                        .length > 0
                                                      ? "col-md-3"
                                                      : "col-md-4"
                                                  }
                                                >
                                                  <div className="form-group">
                                                    <MutextField
                                                      required
                                                      label="State"
                                                      id="state"
                                                      name="state"
                                                      inputProps={{
                                                        maxLength: 32,
                                                      }}
                                                      value={this.state.state}
                                                      placeholder="State"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>

                                                <div
                                                  className={
                                                    this.state
                                                      .listMenuGroupData &&
                                                      this.state.listMenuGroupData
                                                        .length > 0
                                                      ? "col-md-3"
                                                      : "col-md-4"
                                                  }
                                                >
                                                  <div className="form-group">
                                                    <MutextField
                                                      required
                                                      label="Zip"
                                                      id="zip"
                                                      name="zip"
                                                      inputProps={{
                                                        maxLength: 10,
                                                      }}
                                                      value={this.state.zip}
                                                      placeholder="Zip"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      error={
                                                        this.state.errorZip
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    autoComplete="new-password"
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  className={
                                                    this.state
                                                      .listMenuGroupData &&
                                                      this.state.listMenuGroupData
                                                        .length > 0
                                                      ? "col-md-3"
                                                      : "col-md-4"
                                                  }
                                                >
                                                  <div className="form-group">
                                                    <Autocomplete
                                                      id="country"
                                                      className="customCountrySelect-addAgent"
                                                      options={
                                                        this.countryOptions
                                                      }
                                                      getOptionLabel={(option) =>
                                                        option?.label || ""
                                                      }
                                                      value={
                                                        this.countryOptions.find(
                                                          (option) =>
                                                            option.label ===
                                                            this.state.country
                                                        ) || null
                                                      }
                                                      onChange={
                                                        this.handleChangeCountry
                                                      }
                                                      disableClearable
                                                      renderInput={(params) => (
                                                        <MutextField
                                                          {...params}
                                                          required
                                                          name="country"
                                                          label="Country"
                                                          placeholder="Select Country"
                                                          variant="outlined"
                                                          inputProps={{
                                                            ...params.inputProps,
                                                            autoComplete:
                                                              "country",
                                                          }}
                                                        autoComplete="new-password"
                                                        />
                                                      )}
                                                    />
                                                  </div>
                                                </div>

                                                {this.state
                                                  .social_register ? null : (
                                                  <>
                                                    <div className="col-lg-6">
                                                      <div className="form-group">
                                                        <MutextField
                                                          required
                                                          label="Password"
                                                          type={
                                                            this.state
                                                              .passwordShown
                                                              ? "text"
                                                              : "password"
                                                          }
                                                          id="password"
                                                          name="password"
                                                          inputProps={{
                                                            maxLength: 30,
                                                          }}
                                                          defaultValue={
                                                            this.state.password
                                                          }
                                                          placeholder="Enter your password"
                                                          onChange={
                                                            this.handleChange
                                                          }
                                                          variant="outlined"
                                                          fullWidth
                                                          error={
                                                            this.state.errorPass
                                                          }
                                                          autoComplete="new-password"
                                                          helperText="Password must be at
                                                          least 8 characters,
                                                          with uppercase,
                                                          lowercase, number &
                                                          special character."
                                                        />
                                                        <a
                                                          style={{
                                                            cursor: "pointer",
                                                            position:
                                                              "absolute",
                                                            top: "28px",
                                                          }}
                                                          tabIndex="-1"
                                                          onClick={() => {
                                                            this.togglePassword();
                                                          }}
                                                          className="form-icon form-icon-right passcode-switch"
                                                          data-target="password"
                                                        >
                                                          {this.state
                                                            .passwordShown ? (
                                                            <em className="icon ni ni-eye-off"></em>
                                                          ) : (
                                                            <em className="icon ni ni-eye"></em>
                                                          )}
                                                        </a>
                                                        <div>
                                                          <PasswordStrengthBar
                                                            password={
                                                              this.state
                                                                .password
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="col-lg-6">
                                                      <div className="form-group">
                                                        <MutextField
                                                          required
                                                          label="Confirm Password"
                                                          type={
                                                            this.state
                                                              .confirmPasswordShown
                                                              ? "text"
                                                              : "password"
                                                          }
                                                          id="confirm_password"
                                                          name="confirm_password"
                                                          inputProps={{
                                                            maxLength: 30,
                                                          }}
                                                          defaultValue={
                                                            this.state
                                                              .confirm_password
                                                          }
                                                          placeholder="Confirm your password"
                                                          onChange={
                                                            this.handleChange
                                                          }
                                                          variant="outlined"
                                                          fullWidth
                                                          error={
                                                            this.state
                                                              .errorcPass
                                                          }
                                                        autoComplete="new-password"
                                                        />
                                                        <a
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          tabIndex="-1"
                                                          onClick={() => {
                                                            this.toggleConfirmPassword();
                                                          }}
                                                          className="form-icon form-icon-right passcode-switch"
                                                          data-target="password"
                                                        >
                                                          {this.state
                                                            .confirmPasswordShown ? (
                                                            <em className="icon ni ni-eye-off"></em>
                                                          ) : (
                                                            <em className="icon ni ni-eye"></em>
                                                          )}
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </>
                                                )}

                                                <div className="col-lg-4"></div>
                                                <div
                                                  style={{ clear: "both" }}
                                                ></div>

                                                <div className="col-lg-12">
                                                  <div className="form-group text-right">
                                                    <button
                                                      type="button"
                                                      onClick={() =>
                                                        this.formSave()
                                                      }
                                                      className="btn btn-lg btn-primary"
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                    >
                                                      Submit
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                          <div className="container wide-lg mt-3">
                            <div className="row g-3">
                              <div className="col-lg-12">
                                <div className="nk-block-content text-center">
                                  {/* Copyright first */}
                                  <p>
                                    &copy; {new Date().getFullYear()}{" "}
                                    <a
                                      href="https://onboardsoft.com/"
                                      style={{ color: "#526484" }}
                                    >
                                      OnBoardsoft LLC
                                    </a>
                                    . All Rights Reserved.
                                  </p>

                                  {/* Legal links second */}
                                  <div style={{ marginBottom: "15px" }}>
                                    <a
                                      href={`${APP_URL}pages/privacyPolicy`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-decoration-underline"
                                    >
                                      Privacy Policy
                                    </a>
                                    <span className="mx-2">|</span>
                                    <a
                                      href={`${APP_URL}pages/terms-of-service`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-decoration-underline"
                                    >
                                      Terms of Service
                                    </a>
                                  </div>

                                  {/* Login link last (if keeping in footer) */}
                                  <p
                                    style={{
                                      fontSize: "14px",
                                      marginBottom: "0",
                                    }}
                                  >
                                    Already have an account?{" "}
                                    <a
                                      href={APP_URL}
                                      style={{
                                        textDecoration: "none",
                                      }}
                                    >
                                      Login Page
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  },
);
